import { useModal } from '@/store/useZuModal';

function ZustandModals() {
  const modals = useModal(state => state.modals);
  const modalClose = useModal(state => state.modalClose);

  return (
    <>
      {modals.map(({ id, Component, props }) => (
        <Component key={id} onClose={() => modalClose(id)} {...props} />
      ))}
    </>
  );
}

export default ZustandModals;
